import { render, staticRenderFns } from "./Organisations.vue?vue&type=template&id=441c731d&"
import script from "./Organisations.vue?vue&type=script&lang=ts&"
export * from "./Organisations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports